import React, { useState, useEffect } from 'react'
import api from '../../API/api';
import { Paper, Divider } from '@mui/material';


function AchievementCard({ id }) {

    const [achivement, setAchivement] = useState();
    const [achivementFaculty, setAchivementFaculty] = useState();
    const [count , setCount] = useState();

    function getachiv() {
        api.getAchievment().then(res => {
            let filterData = res.data.filter(obj => obj.user_type == 'student' && obj.school_id == Number(id))
            // console.log(res.data, 'filterData');
            setCount(res.data)
            setAchivement(filterData)
            let filterData2 = res.data.filter(obj => obj.user_type == 'faculty' && obj.school_id == Number(id))
            setAchivementFaculty(filterData2)
        }).catch(err => {

        })
    }

    useEffect(() => {
        getachiv();
    }, [id])

    return (
        <Paper>
            <div className='m-3'>
                {achivement?.length !== 0 &&
                    <h2 className='text-center'>Achievements</h2>
                }

                <div className='col-12'>

                    <div className="row">
                        {achivement?.map((item) => (
                            // {achivement?.filter((el) => el.user_type === 'student').map((item) => (
                            <div className="col-md-3 p-2">
                                <Paper elevation={3}>
                                    <div className="row">
                                        <div className='text-center my-2'>
                                            <div>
                                                <h6> <strong> {item.title} </strong> </h6>
                                            </div>
                                            <img className='col-10' src={`${process.env.REACT_APP_BACKEND}assets/achiement/${item.image}`} />
                                        </div>
                                        <div className='text-center my-2'>
                                            <small className='bg-lcoation'>Date : {item.date}</small>
                                        </div>
                                        <div className='text-center mb-2'>
                                            <div>
                                                <strong> {item.user_name}</strong>
                                            </div>
                                            <div>
                                                {item.user_type === 'student' ?
                                                    <span className='text-warning'>
                                                        Student
                                                    </span> :
                                                    <span className='text-primary'>
                                                        Faculty
                                                    </span>}
                                            </div>
                                            <Divider />
                                        </div>
                                        <div className='text-center mb-2'>
                                            <span> {item.short_desc}</span>
                                        </div>
                                    </div>
                                </Paper>
                            </div>

                        ))}
                    </div>
                </div>

            </div>
        </Paper>
    )
}

export default AchievementCard